import { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { monitoringApi, DivergenceRecord, MonitoringApiError, DivergenceParams } from '../../../../services/monitoringApi';

export default function useMonitoringDivergences(personId: string | null) {
    const [items, setItems] = useState<DivergenceRecord[]>([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(50);
    const [isLoading, setIsLoading] = useState(false);

    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');

    const fetchData = useCallback(async () => {
        if (!personId) return;
        setIsLoading(true);
        try {
            const params: DivergenceParams = {
                page,
                pageSize,
                dateFrom: dateFrom || undefined,
                dateTo: dateTo || undefined,
            };
            const result = await monitoringApi.getDivergences(personId, params);
            setItems(result.data?.items || []);
            setTotal(result.data?.total || 0);
        } catch (e: unknown) {
            if (e instanceof MonitoringApiError) {
                toast.error(e.message);
            } else {
                toast.error('Erro ao carregar divergências');
            }
            setItems([]);
            setTotal(0);
        } finally {
            setIsLoading(false);
        }
    }, [personId, page, pageSize, dateFrom, dateTo]);

    useEffect(() => {
        if (personId) {
            setPage(1);
            setItems([]);
        }
    }, [personId]);

    useEffect(() => { fetchData(); }, [fetchData]);

    const totalPages = Math.max(1, Math.ceil(total / pageSize));

    return {
        items,
        total,
        page,
        setPage,
        pageSize,
        totalPages,
        isLoading,
        dateFrom,
        setDateFrom,
        dateTo,
        setDateTo,
    };
}
